module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/chat-2-e9192feb325ad5d58a6ed2c663840c5b.svg";